import $ from "jquery";

export const Notification = function () {
	const $elms = {
		wrapper: $(".js-event-popup"),
		btnClose: $(".js-close-event-btn"),
	};

	$($elms.btnClose).on("click", function () {
		const $wrapper = $(this).closest(".js-event-popup");
		$wrapper.removeClass("is-open");

		const eventId = $wrapper.attr("notif-id");
		localStorage.setItem(`notif-${eventId}`, 1);
	});

	if ($elms.wrapper.length) {
		$elms.wrapper.each(function () {
			const $this = $(this);

			const eventId = $this.attr("notif-id");
			if (eventId) {
				const notifShowed = localStorage.getItem(`notif-${eventId}`) || 0;
				if (notifShowed != 1) {
					$this.addClass("is-open");
				}
			}
		});
	}
};
